export default "__VITE_ASSET__B3UWF7Pf__"